<template>
    <div>
        <template v-for="item in items">
          <li class="dropdown-item text-small" :key="item.id"
              :style="'padding-left:'+ (10 * level)+'px'"
              @click="$emit('click',item)"
          >
            {{item.name}}
          </li>
          <template v-if="item[children] && item[children].length">
            <custom-select-tree
                :items="item[children]"
                :level="level + 1"
                @click="$emit('click',$event)"
            ></custom-select-tree>
          </template>
        </template>
    </div>
</template>

<script>
export default {
  name: "CustomSelectTree",
  props:{
    level: {
      type: Number,
      default:1
    },
    items: {
      type: [Array,Object],
      default() {
        return [];
      },
    },
    children:{
      type:String,
      default:'children'
    }
  }
}
</script>

<style scoped>

</style>